import { memo } from "react";
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const RiskAndComplianceLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.HighRiskMerchant].RiskAndCompliance}`}
        Icon={ContentPasteIcon}
        {...props}
    >
        Risk and Compliance
    </StepLabel>
);

export default memo(RiskAndComplianceLabel);
